/** PWS module FormTypeIDs — PWS (18) and Reclaimed (19) share the PWS module. */
export const PWS_FORM_TYPE_IDS = [18, 19];

export const PWS_COMPLIANCE_MENU_IDS = [
  'weekly-flow-meter-logs',
  'weekly-equipment-service-logs',
  'weekly-pws-water-monitoring',
  'monthly-pws-water-sample',
  'monthly-pws-analytical-report-review',
  'quarterly-dlqor',
  'quarterly-colorimeter-calibration-verification'
];

export const RECLAIMED_MENU_IDS = [
  'weekly-reclaimed-water-monitoring',
  'monthly-reclaimed-water-sample',
  'monthly-reclaimed-analytical-report-review',
  'semi-annual-reclaimed-water-sample',
  'semi-annual-reclaimed-analytical-report-review',
  'annual-reclaimed-water-sample',
  'annual-reclaimed-analytical-report-review',
  'monthly-lab-summary'
];

export const ALL_PWS_MODULE_MENU_IDS = [
  ...PWS_COMPLIANCE_MENU_IDS,
  ...RECLAIMED_MENU_IDS
];

const normalizeRoleKey = (role) =>
  String(role?.roleName ?? role?.RoleName ?? role ?? '')
    .toLowerCase()
    .replace(/\s+/g, '');

export const getUserRoleKeys = (user) => {
  if (!user?.roles) return [];
  if (Array.isArray(user.roles)) {
    return user.roles.map(normalizeRoleKey).filter(Boolean);
  }
  if (typeof user.roles === 'string') return [user.roles.toLowerCase()];
  return [];
};

export const userHasPwsRole = (user) => {
  const roles = getUserRoleKeys(user);
  return roles.includes('pwsmanager') || roles.includes('pwsuser');
};

export const userHasCompanyAssignment = (user) =>
  Array.isArray(user?.companyAssignments) && user.companyAssignments.length > 0;

const normalizeModuleCode = (entry) =>
  String(entry?.code ?? entry?.Code ?? entry ?? '')
    .toUpperCase()
    .trim()
    .replace(/\s+/g, '_');

const normalizeModuleName = (value) => {
  if (value == null) return '';
  return String(value).trim().toLowerCase().replace(/\s+/g, ' ');
};

/** Company has PWS module active (module code, form types 18/19, or PWS-related form title). */
export const userHasPwsModuleActive = (user) => {
  const activeModuleCodes = user?.activeModuleCodes ?? [];
  if (activeModuleCodes.some((entry) => {
    const code = normalizeModuleCode(entry);
    return code === 'PWS' || code.includes('PWS');
  })) {
    return true;
  }

  const activeModules = user?.activeModules ?? [];
  for (const moduleRow of activeModules) {
    const formTypeId = Number(moduleRow?.FormTypeID ?? moduleRow?.formTypeID);
    if (PWS_FORM_TYPE_IDS.includes(formTypeId)) return true;

    const moduleName = normalizeModuleName(
      moduleRow?.ModuleName
      ?? moduleRow?.moduleName
      ?? moduleRow?.FormTitle
      ?? moduleRow?.FormName
      ?? moduleRow?.Title
      ?? moduleRow?.Name
    );
    if (
      moduleName.includes('pws')
      || moduleName.includes('reclaimed')
      || moduleName.includes('public water')
    ) {
      return true;
    }
  }

  return false;
};

/** User can see the PWS/Reclaimed module: global admin, or company-assigned companyadmin/pws role + active module. */
export const userCanAccessPwsModule = (user) => {
  if (!user) return false;
  const roles = getUserRoleKeys(user);
  if (roles.includes('globaladmin')) return true;
  const hasPwsEntitledRole = userHasPwsRole(user) || roles.includes('companyadmin');
  return hasPwsEntitledRole
    && userHasCompanyAssignment(user)
    && userHasPwsModuleActive(user);
};
